import type {DisplayType, ThumbNailType} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';
import type {SubFlowType} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/digital-signage-compiled-sub-panel/digital-signage-compiled-sub-panel.types';
import type {DigitalSignageProviderSubFlow} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/publishing-digital-signage-list.types';
import type {SocialPlatform} from '@Components/social-media/social-media.types';
import type {ReactElement} from 'react';

export interface PublishingOptionsDefaultListProps {
  closePanel: () => void;
  displayType: DisplayType;
  recommendedOptions?: PublishingOptionsList[];
}

export type PublishingOptionLoadingKey = PublishingOptionsList | SocialPlatform | DigitalSignageProviderSubFlow;

export interface PublishingOptions {
  id: string;
  iconName: string;
  heading: string;
  afterHeadingTextContent?: ReactElement;
  subheading?: string;
  thumbNailType: ThumbNailType;
  imgSrc?: string;
  showTwoButtons?: boolean;
  customThumbnailClasses?: string;
  onClick?: VoidFunction;
  subFlowType?: SubFlowType;
  posterId?: string;
  price?: string;
  gaTracking?: VoidFunction;
}

export enum PublishingOptionsList {
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  DIGITAL_SIGNAGE = 'DIGITAL_SIGNAGE',
  WEB_LINK = 'WEB_LINK',
  EMAIL_CAMPAIGN = 'EMAIL_CAMPAIGN',
  DOWNLOADED_POSTER = 'DOWNLOADED_POSTER',
  EMBED_IN_WEBPAGE = 'EMBED_IN_WEBPAGE',
  SHARE_ON_SOCIAL_MEDIA = 'SHARE_ON_SOCIAL_MEDIA',
  SHARE_TO_APP = 'SHARE_TO_APP',
  QR_CODE = 'QR_CODE',
  PROMOTE_AS_EVENT = 'PROMOTE_AS_EVENT',
  INVITE = 'INVITE',
}
